import {clsx} from '@gfiber/typesmith';
import React from 'react';
import styles from './Elevation.module.scss';

export interface ElevationProps {
  /** The elevation level (depth), typically 0, 2, 4, 8, etc. */
  z?: number;
  /** If true, wraps children in a div. If false, clones the child and adds the class. */
  wrap?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Elevation: React.FC<ElevationProps> = ({
  z = 0,
  wrap = false,
  children,
  className,
}) => {
  const elevationClass = styles[`z${z}`];

  // Wrap the children with a div element
  if (wrap) {
    return <div className={clsx(elevationClass, className)}>{children}</div>;
  }

  // Apply the class directly to the child element
  if (React.Children.count(children) === 1 && React.isValidElement(children)) {
    const child = React.Children.only(children) as React.ReactElement<
      Record<string, unknown>
    >;
    return React.cloneElement(child, {
      className: clsx(
        child.props.className as string,
        elevationClass,
        className,
      ),
    });
  }

  // Fallback
  return <>{children}</>;
};
